goog.provide('el8.util.amplitude.immunizationHelpers');

goog.require('el8.util.amplitude.helpers');

/**
 * Helper method to convert a boolean to a 'yes'/'no' string value
 *
 * @param {boolean} bool
 */
function convertBoolToYesNo(bool) {
  return bool ? 'yes' : 'no';
}

/**
 * Log when immunization table is opened
 *
 * @param {string} source the name of the source of the event
 */
el8.util.amplitude.logImmunizationTableOpen = function(source) {
    try {
        var ampData = {
            immtable_button: source
        };
        el8.util.amplitude.logEvent('Immunizations - immunization table', ampData);
    } catch (err) {
        console.warn(err);
    }
};

/**
 * Log when immunization dialog is opened
 *
 * @param {string} source the name of the source of the event
 */
el8.util.amplitude.logImmunizationDialogOpen = function(source) {
    try {
        var ampData = {
            docimm_button: source
        };
        el8.util.amplitude.logEvent('Immunizations - open immunization dialog', ampData);
    } catch (err) {
        console.warn(err);
    }
};

/**
 * Log when choosing the print immunizations option in the clinical profile
 */
el8.util.amplitude.logImmunizationClinicalProfilePrint = function() {
    try {
        var ampData = {
            printimmhx_clinprof: 'yes'
        };
        el8.util.amplitude.logEvent('Immunizations - clinical profile immunization', ampData);
    } catch (err) {
        console.warn(err);
    }
};

/**
 * Log when exporting immunizations from the clinical profile
 */
el8.util.amplitude.logImmunizationExportToNote = function() {
    try {
        var ampData = {
            imm_exporttonote: 'yes'
        };
        el8.util.amplitude.logEvent('Immunizations - immunization export', ampData);
    } catch (err) {
        console.warn(err);
    }
};

/**
 * Log when immunization table documentation action item is selected
 *
 * @param {string} action the name of the action menu item
 */
el8.util.amplitude.logImmunizationTableAction = function(action) {
    try {
        var ampData = {
            doc_imm: action
        };
        el8.util.amplitude.logEvent('Immunizations - immunization table documentation', ampData);
    } catch (err) {
        console.warn(err);
    }
};

/**
 * Log when immunization table buttons are clicked
 *
 * @param {string} eventProp the name of the event property related to the button being clicked
 */
el8.util.amplitude.logImmunizationTableButton = function(eventProp) {
    try {
        var ampData = {};
        ampData[eventProp] = 'yes';
        el8.util.amplitude.logEvent('Immunizations - immunization table', ampData);
    } catch (err) {
        console.warn(err);
    }
};

/**
 * Log when immunization dialog action item is selected
 *
 * @param {string} action the name of the action item selected
 */
el8.util.amplitude.logImmunizationDialogAction = function(action) {
    try {
        var ampData = {
            immdialog_button: action
        };
        el8.util.amplitude.logEvent('Immunizations - immunization dialog actions', ampData);
    } catch (err) {
        console.warn(err);
    }
};

/**
 * Log when immunization dialog details are saved
 *
 * @param {Object} data immunization details upon dialog save
 * @param {boolean} data.adminProvider whether admin provider was provided
 * @param {boolean} data.consent whether consent was given
 * @param {boolean} data.notes whether notes were provided
 * @param {boolean} data.orderProvider whether order provider was provided
 * @param {string} data.patientPopulation patient population selection
 * @param {boolean} data.reason whether a reason was provided
 * @param {boolean} data.submitRegistry whether immunization was sent to registry
 */
el8.util.amplitude.logImmunizationDialogSave = function(data) {
    try {
        var ampData = {
            admin_providerEPN: convertBoolToYesNo(data.adminProvider),
            imm_consent: convertBoolToYesNo(data.consent),
            imm_notes: convertBoolToYesNo(data.notes),
            imm_reason: convertBoolToYesNo(data.reason),
            order_providerEPN: convertBoolToYesNo(data.orderProvider),
            patient_population: data.patientPopulation,
            submit_registry: convertBoolToYesNo(data.submitRegistry)
        };
        el8.util.amplitude.logEvent('Immunizations - immunization dialog', ampData);
    } catch (err) {
        console.warn(err);
    }
}

/**
 * Log when add patient info button in immunization dialog is clicked
 */
el8.util.amplitude.logImmunizationDialogDemographicUpdate = function() {
    try {
        var ampData = {
            addaddress_button: 'dialog'
        };
        el8.util.amplitude.logEvent('Immunizations - immunization dialog demographic update', ampData);
    } catch (err) {
        console.warn(err);
    }
};

/**
 * Log when add patient info button in immunization dialog is clicked
 */
el8.util.amplitude.logImmunizationDialogLearnMoreLink = function() {
    try {
        var ampData = { required_imm_fields_learn_more: 'dialog' };
        el8.util.amplitude.logEvent('Immunizations - immunization dialog learn more', ampData);
    } catch (err) {
        console.warn(err);
    }
};

/**
 * Log when Immunization History Dialog open button is clicked
 */
el8.util.amplitude.logImmunizationHistoryOpenHistoryDialog = function(buttonLocation) {
    try {
        var ampData = { immhx_button: buttonLocation }
        el8.util.amplitude.logEvent('Immunization History - open immunization history dialog', ampData);
  } catch (err) {
        console.warn(err);
  }
}

/**
 * Log when Immunization Forecast Dialog open button is clicked
 */
el8.util.amplitude.logImmunizationForecastOpenForecastDialog = function(buttonLocation) {
    try {
        var ampData = { immforecast_button: buttonLocation }
        el8.util.amplitude.logEvent('Immunization Forecast - open immunization forecast dialog', ampData);
  } catch (err) {
        console.warn(err);
  }
}
